import { FC } from 'react'
import ReactMarkdown from 'react-markdown'

export interface AppMarkdownViewerProps {
  markdown: string
  className?: string
}

export const AppMarkdownViewer: FC<AppMarkdownViewerProps> = ({ markdown, className }) => {
  return (
    <div className={className}>
      <ReactMarkdown
        components={{
          h1: ({ children }) => <h1 className="text-2xl font-bold text-dark-blue mb-3 mt-4">{children}</h1>,
          h2: ({ children }) => <h2 className="text-xl font-bold text-orange mb-3 mt-4">{children}</h2>,
          h3: ({ children }) => <h3 className="text-lg font-semibold text-dark-blue mb-2 mt-3">{children}</h3>,
          p: ({ children }) => <p className="mb-2">{children}</p>,
          ul: ({ children }) => <ul className="list-disc ml-6 my-2">{children}</ul>,
          ol: ({ children }) => <ol className="list-decimal ml-6 my-2">{children}</ol>,
          li: ({ children }) => <li className="my-1">{children}</li>,
          strong: ({ children }) => <strong className="font-bold">{children}</strong>,
          em: ({ children }) => <em className="italic">{children}</em>,
          a: ({ href, children }) => (
            <a href={href} target="_blank" rel="noreferrer" className="text-orange underline">
              {children}
            </a>
          ),
          blockquote: ({ children }) => (
            <blockquote className="border-l-4 border-orange pl-4 my-2 text-stone-gray italic">{children}</blockquote>
          ),
          code: ({ children }) => <code className="bg-soft-gray px-1 rounded text-sm font-mono">{children}</code>,
          hr: () => <hr className="my-4 border-soft-gray" />,
        }}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  )
}
